
import html from '../assets/svg/skills/html.svg'
import css from '../assets/svg/skills/css.svg'
import javascript from '../assets/svg/skills/javascript.svg'
import nextJS from '../assets/svg/skills/nextJS.svg'
import react from '../assets/svg/skills/react.svg'
import typescript from '../assets/svg/skills/typescript.svg'
import bootstrap from '../assets/svg/skills/bootstrap.svg'
import mongoDB from '../assets/svg/skills/mongoDB.svg'
import tailwind from '../assets/svg/skills/tailwind.svg'
import firebase from '../assets/svg/skills/firebase.svg'
import figma from '../assets/svg/skills/figma.svg'
import microsoftoffice from '../assets/svg/skills/microsoftoffice.svg'
import canva from '../assets/svg/skills/canva.svg'
import expressjs from '../assets/svg/skills/expressjs-icon.svg'
import nodejs from '../assets/svg/skills/nodejs-icon.svg'
import heroku from '../assets/svg/skills/heroku-icon.svg'
import netlify from '../assets/svg/skills/netlify-icon.svg'
import github from '../assets/svg/skills/github-icon.svg'
import visualstudio from '../assets/svg/skills/visualstudio_code-icon.svg'
import msword from '../assets/svg/skills/microsoft-word-seeklogo.com.svg'
import mspowerpoint from '../assets/svg/skills/microsoft-powerpoint-seeklogo.com.svg'
import msExcel from '../assets/svg/skills/microsoft-excel-seeklogo.com.svg'

export const skillsImage = (skill) => {
    const skillID = skill.toLowerCase();
    switch (skillID) {
       
        case 'html':
            return html;
        case 'css':
            return css;
        case 'javascript':
            return javascript;
        case 'next js':
            return nextJS;
        case 'react':
            return react;
        case 'typescript':
            return typescript;
        case 'bootstrap':
            return bootstrap;
        case 'mongodb':
            return mongoDB;
        case 'tailwind':
            return tailwind;
        case 'firebase':
            return firebase;
        case 'figma':
            return figma;
        case 'microsoftoffice':
            return microsoftoffice;
        case 'canva':
            return canva;
        case 'expressjs':
            return expressjs;
        case 'nodejs':
            return nodejs;
        case 'heroku':
            return heroku;
        case 'netlify':
            return netlify;
        case 'github':
            return github;
        case 'visualstudio':
            return visualstudio;
        case 'msword':
            return msword;
        case 'msExcel':
            return msExcel;
        case 'mspowerpoint':
            return mspowerpoint;
        default:
            break;
    }
}
